import * as React from 'react';
import { getReliability } from '../../selectors/developerV2';
import { useSelector } from 'react-redux';
import { Reliability } from '../../components/ReliableBlock';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDeviceType } from '@cian/ui-kit';
import { trackShowMobileReliabilityBlock } from './tracking';

export const ReliabilityContainer = () => {
  const reliability = useSelector(getReliability);
  const deviceType = useDeviceType();

  const onShow = React.useCallback(() => {
    if (deviceType === 'desktop') {
      return;
    }

    trackShowMobileReliabilityBlock();
  }, [deviceType]);

  if (!reliability) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={onShow} triggerOnce>
      <Reliability
        status={reliability.reliableBlock.type}
        title={reliability.reliableBlock.text}
        details={reliability.reliableParams}
        description={reliability.reliableBlock.description}
      />
    </ActionAfterViewObserver>
  );
};
